module.exports = __webpack_public_path__ + "img/linked-in.c1f21366.svg";